import { Connection, PublicKey } from '@solana/web3.js';
import { HTLCPublicClient } from '@train-protocol/sdk';
import { NATIVE_SOL_ADDRESS } from '../constants.js';
import { buildProgram as buildProgramHelper } from './helpers.js';
import { getUserLockDetails as getUserLockDetailsFn } from './public/getUserLockDetails.js';
import { getSolverLockDetails as getSolverLockDetailsFn } from './public/getSolverLockDetails.js';
import { recoverSwap as recoverSwapFn } from './public/recoverSwap.js';
import { getTransaction as getTransactionFn } from './public/getTransaction.js';
export class SolanaHTLCPublicClient extends HTLCPublicClient {
    constructor(config) {
        super();
        this.connection = new Connection(config.rpcUrl, 'confirmed');
    }
    // ── Read Operations ────────────────────────────────────────────────
    async getUserLockDetails(params) {
        return getUserLockDetailsFn(this.connection, params, (contractAddress, connection) => this.buildProgram(contractAddress, undefined, connection));
    }
    async getSolverLockDetails(params, nodeUrl) {
        return getSolverLockDetailsFn(params, nodeUrl, (contractAddress, connection) => this.buildProgram(contractAddress, undefined, connection));
    }
    async recoverSwap(txHash, network) {
        return recoverSwapFn(this.connection, txHash, network, (params) => this.getUserLockDetails(params));
    }
    // ── Public Helpers ─────────────────────────────────────────────────
    async getTransaction(txHash) {
        return getTransactionFn(this.connection, txHash);
    }
    // ── Protected Helpers ──────────────────────────────────────────────
    buildProgram(contractAddress, readerKey, connection) {
        return buildProgramHelper(contractAddress, connection ?? this.connection, readerKey ?? new PublicKey(NATIVE_SOL_ADDRESS));
    }
}
